import CampaignServices from "../../services/CampaignServices";
const campaignServices = new CampaignServices();
import LoaderUtils from "../../utils/BaseUtils/LoaderUtils";
import StoreUtils from "../../utils/BaseUtils/StoreUtils";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export const namespaced = true;

export const state = {
  allCampaigns: [],
  singleCampaign: {}
};

export const getters = {
  getAllCampaigns: state => {
    return state.allCampaigns;
  },
  getSingleCampaign: state => {
    return state.singleCampaign;
  }
};

export const mutations = {
  SET_ALL_CAMPAIGNS(state, payload) {
    state.allCampaigns = payload;
  },
  SET_SINGLE_CAMPAIGN(state, payload) {
    state.singleCampaign = payload;
  }
};

export const actions = {
  fetchActiveCampaigns() {
    let payload = { readAll: "YES" };

    let successAction = responseData => {
      StoreUtils.commit("campaign/SET_ALL_CAMPAIGNS", responseData.data);
    };

    campaignServices.fetchActiveCampaigns(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  },
  fetchSingleCampaign(undefined, payload) {
    let successAction = responseData => {
      StoreUtils.commit("campaign/SET_SINGLE_CAMPAIGN", responseData);
      RouterUtils.changeRouteTo(RouterUtils.routes.PRODUCTDETAILS);
    };

    campaignServices.fetchSingleCampaign(
      payload,
      successAction,
      LoaderUtils.types.BLOCKING
    );
  }
};
